import TranslationService from './translationService'


export enum Services {
  Translation = 'translation'
}

export class ServiceFactory {

  private static services: any = {}

  public static get (name: Services) : any {
    const service = this.services[name]

    if (!service) {
      let newService: any

      switch (name) {
      case Services.Translation: {
        newService = new TranslationService()
        break
      }
      }

      this.services[name] = newService
      return newService
    }

    return service
  }
}
